<template>
  <v-alert
    class="alert-bar ma-0"
    :type="type"
    :value="value"
    @input="$emit('input', $event)"
    dense
    tile
    single-line
    text
    dismissible
    transition="slide-y-transition"
  >
    <v-row align="center">
      <v-col class="grow py-0">{{ message }}</v-col>
      <v-col class="shrink py-0" v-if="detail">
        <v-btn
          class="alert__details-button"
          :class="{
            'info--text': type === 'info',
            'error--text': type === 'error',
            'warning--text': type === 'warning'
          }"
          text
          @click.stop="showDetail = true"
          >Details</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="showDetail">
      <v-card class="alert-bar__details">
        <v-toolbar class="white--text" dense color="secondary">
          <v-toolbar-title>
            {{ message }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span v-html="detail"></span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="showDetail = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-alert>
</template>

<script>
export default {
  name: 'AlertBar',
  props: {
    value: Boolean,
    type: String,
    message: String,
    detail: String
  },
  data() {
    return {
      showDetail: false
    }
  }
}
</script>

<style lang="scss" scoped>
button.v-btn.alert__details-button {
  height: 22px;
}
.alert-bar__details.v-card {
  .v-card__text {
    padding-top: 16px;
  }
}
</style>
